export type SchedulerConfig = { delay: number };

export class Scheduler {
  subscribers: Function[];
  interval: ReturnType<typeof setInterval> | null;
  isStopped: boolean;
  config: SchedulerConfig;
  timeElapsed: number;
  onTickCallback: ((timeElapsed: number) => void) | null;

  constructor(config: SchedulerConfig) {
    this.subscribers = [];
    this.config = config;
    this.interval = null;
    this.onTickCallback = null;
    this.isStopped = false;
    this.timeElapsed = 0;
  }

  subscribe(cb: Function) {
    this.subscribers.push(cb);
  }

  execute() {
    this.subscribers.forEach((sub) => sub?.());
  }

  runInterval() {
    this.interval = setInterval(() => {
      this.timeElapsed += 1000;
      this.onTickCallback?.(this.timeElapsed);
      if (this.timeElapsed >= this.config.delay) this.execute();
    }, 1000);
  }

  start() {
    if (this.isStopped) return;
    this.runInterval();
  }

  stop() {
    this.isStopped = true;
    this.interval && clearInterval(this.interval);
    this.timeElapsed = 0;
  }

  resume() {
    this.isStopped = false;
    this.runInterval();
  }

  reset() {
    this.isStopped = false;
    this.subscribers = [];
    this.interval && clearInterval(this.interval);
    this.timeElapsed = 0;
    console.log("Scheduler reset successfull.");
  }

  onTick(callback: typeof this.onTickCallback) {
    this.onTickCallback = callback;
  }
}

export function formatSeconds(seconds: number) {
  // Calculate hours, minutes and seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Format each time component to be two digits
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  // Combine the components into a single string
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}
